<template>
  <div class="flex flex-col place-items-center">
    <img src="../../assets/logo_trans.png" class="h-20 p-4" />
    <p class="font-opensans">U kunt hier inloggen op het DSAportaal</p>
    <div
      class="
        border border-mi-blue-500
        shadow-lg
        px-8
        rounded-lg
        m-2
        pt-2
        max-w-md
      "
    >
      <div
        class="
          -mx-8
          mb-4
          border-b border-mi-blue-500
          rounded-t-lg
          flex flex-row
        "
      >
        <div
          class="
            mx-2
            border-b
            hover:border-mi-blue-500 hover:font-semibold
            cursor-pointer
          "
          :class="{
            'border-mi-blue-500': show_login,
            'font-semibold': show_login,
          }"
          @click="show_login = true"
        >
          Login
        </div>
        <div
          class="
            mx-2
            border-b
            hover:border-mi-blue-500 hover:font-semibold
            cursor-pointer
          "
          :class="{
            'border-mi-blue-500': !show_login,
            'font-semibold': !show_login,
          }"
          @click="show_login = false"
        >
          Registreren
        </div>
      </div>
      <FormulateForm class="input" @submit="login" v-if="show_login">
        <FormulateInput
          type="text"
          name="username"
          v-model="username_login"
          validation="required"
          :wrapper-class="['login-wrapper-class']"
          input-class="bg-gray-200 border border-transparent rounded-md w-full
        px-2 mb-3 focus:border-mi-blue-600 focus:bg-white placeholder-black
        placeholder-opacity-100"
          aria-placeholder="Gebruikersnaam"
          placeholder="E-mail/gebruikersnaam"
          :validation-messages="{ required: 'Gebruikersnaam is verplicht' }"
        />
        <FormulateInput
          type="password"
          name="password"
          v-model="password"
          validation="required"
          :wrapper-class="['login-wrapper-class']"
          aria-placeholder="Wachtwoord"
          input-class="bg-gray-200 border border-transparent rounded-md w-full px-2 focus:border-mi-blue-600 focus:bg-white placeholder-black placeholder-opacity-100"
          placeholder="Wachtwoord"
          :validation-messages="{
            required: 'Wachtwoord is verplicht',
          }"
        />

        <FormulateInput
          label="Login"
          type="submit"
          input-class="bg-mi-blue-500 text-center rounded-lg text-white w-full mt-4"
        />
      </FormulateForm>

      <FormulateForm class="input" @submit="register" v-else>
        <FormulateInput
          type="text"
          name="username"
          v-model="username_register"
          validation="required|alphanumeric"
          :wrapper-class="['login-wrapper-class']"
          input-class="bg-gray-200 border border-transparent rounded-md w-full
        px-2 mb-3 focus:border-mi-blue-600 focus:bg-white placeholder-black
        placeholder-opacity-100"
          aria-placeholder="Gebruikersnaam"
          placeholder="Gebruikersnaam"
          :validation-messages="{
            required: 'Gebruikersnaam is verplicht',
            alphanumeric:
              'Een gebruikersnaam mag alleen uit letters en cijfers bestaan (geen spaties).',
          }"
        />
        <FormulateInput
          type="email"
          name="email"
          v-model="email"
          validation="required|email"
          :wrapper-class="['login-wrapper-class']"
          aria-placeholder="Email"
          input-class="bg-gray-200 border border-transparent rounded-md w-full px-2 focus:border-mi-blue-600 focus:bg-white placeholder-black placeholder-opacity-100"
          placeholder="Email"
          :validation-messages="{
            required: 'E-mail is verplicht',
            email: 'E-mailadres is niet geldig',
          }"
        />

        <FormulateInput
          label="Registreren"
          type="submit"
          input-class="bg-mi-blue-500 text-center rounded-lg text-white w-full mt-4"
        />
      </FormulateForm>
      <div class="flex flex-row">
        <p class="flex flex-grow"></p>
        <router-link
          class="flex text-gray-500 text-sm"
          :to="{ name: 'ForgotPassword' }"
          v-if="show_login"
        >
          Wachtwoord vergeten
        </router-link>
      </div>
      {{ this.error_msg }}
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      username_login: "",
      username_register: "",
      email: "",
      password: "",
      error_msg: null,
      show_login: true,
    };
  },
  computed: {
    loggedIn: function () {
      return this.$store.getters.current_user;
    },
  },
  methods: {
    login: async function () {
      let response = await this.$store.dispatch("login", {
        username: this.username_login,
        password: this.password,
      });
      if ("error" in response) {
        this.error_msg = "Gebruikersnaam of wachtwoord onjuist";
      } else {
        await this.$store.dispatch("loadBackendData");
        if (this.$router.currentRoute.name !== "Home") {
          this.$router.push("/");
        }
      }
    },
    register: async function () {
      this.error_msg = null;
      let response = await this.$store.dispatch("registerPublicUser", {
        username: this.username_register,
        email: this.email,
      });
      this.error_msg =
        "U ontvangt een e-mail met instructies om uw account te activeren.";
      if ("error" in response) this.error_msg = "Kan gebruiker niet aanmaken";
    },
    ...mapActions(["logout"]),
  },
  watch: {
    loggedIn() {
      if (this.loggedIn && this.$router.currentRoute.name !== "Home") {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style>
.login-wrapper-class {
  @apply block;
}
</style>
